// extracted by mini-css-extract-plugin
var _1 = "Header-moduleHeader__xYejq";
export { _1 as "Header" }
